/* eslint-disable @typescript-eslint/naming-convention */
export enum Language {
  en = 'English',
  nl = 'Nederlands',
  tr = 'Türkçe',
  zh = '中文'
}
